var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-menu-link"},[_c('router-link',{attrs:{"to":_vm.linkTo,"title":_vm.title}},[_c('i',{staticClass:"icon",class:_vm.iconName})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }